import { render, staticRenderFns } from "./CompanyCostItemConfig.vue?vue&type=template&id=4710a45d&"
import script from "./CompanyCostItemConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyCostItemConfig.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCostItemConfig.vue?vue&type=style&index=0&id=4710a45d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports